const hamburgerButton = document.getElementById("menu-button");

// Add click handler to toggle the class on hamburger button click
hamburgerButton.addEventListener("click", (event) => {
  const isOpen = hamburgerButton.getAttribute("aria-expanded") === "false";
  // isOpen = !isOpen;
  hamburgerButton.setAttribute("aria-expanded", isOpen);
  event.preventDefault();

  event.stopPropagation(); // Prevent the document click from firing
  document.body.classList.toggle("nav-menu-open");
});

// Add classes for active animation because iOS doesn't
// reliably trigger :active states
hamburgerButton.addEventListener("pointerdown", () =>
  hamburgerButton.classList.add("is-active"),
);
hamburgerButton.addEventListener("pointerup", () =>
  hamburgerButton.classList.remove("is-active"),
);
hamburgerButton.addEventListener("pointerleave", () =>
  hamburgerButton.classList.remove("is-active"),
);
hamburgerButton.addEventListener("pointercancel", () =>
  hamburgerButton.classList.remove("is-active"),
);

function closeMenu() {
  hamburgerButton.setAttribute("aria-expanded", false);
  document.body.classList.remove("nav-menu-open");
}

// Add click handler to document to remove the class on clicks elsewhere
document.addEventListener("click", (event) => {
  if (document.body.classList.contains("nav-menu-open")) {
    // Check if the click target is inside the nav.menu-header-nav container
    const navContainer = event.target.closest("nav.menu-header-nav");
    if (!navContainer) {
      event.preventDefault();
      event.stopPropagation();
      closeMenu();
    }
  }
});
